import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    ElementRef, EventEmitter,
    Input,
    OnInit, Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {CommonDataService} from 'app/services/common-data.service';
import {ISubscription} from "rxjs/Subscription";
import {StocksFilter, StocksFilterGUID} from "../../models/stocks-filter";
import {StocksFiltersState} from 'app/stocks/models/stocks-filters-state';
import {FilterControlSettings} from "../../models/filter-control-settings";
import {SelectedFilter} from 'app/stocks/models/selected-filter';
import {Focus} from 'app/stocks/models/focus';
import {AdditionalFilterData, AdditionalFilterDataGUID} from "../../models/additional-filter-data";
import {StocksHelper} from "../../models/stocks-helper";
import {StocksFiltersStateGUID} from "../../models/stocks-filters-state";
import {SelectedFilterGUID} from "../../models/selected-filter";
import {FocusGUID} from "../../models/focus";
import {ComponentInfo} from "../../../shared/models/component-info";
import {CommonService} from "../../../services/common.service";
import {StocksToolbarButtonsSettings} from "../../../shared/models/stocks-toolbar-settings";
import {TabSelect} from "../../../shared/models/tab-select";

type InitialData = { accessDenied: boolean, rights: any };

export enum STMainFilterBtn{
    cancel = 0,
    clear = 1,
    apply = 2
}

@Component({
    selector: 'main-filter',
    templateUrl: './main-filter.component.html',
    styleUrls: ['./main-filter.component.css']
})
export class MainFilterComponent implements OnInit, AfterViewInit, AfterViewChecked{

    constructor(public readonly translateService: TranslateService,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                public readonly commonService: CommonService,
                private filterService: StocksFilterService,
                public readonly renderer: Renderer2){
        this.locale = localStorage['UserLocale'];
        // this.close = new EventEmitter();
        this.showAllFilters = true;
        this.develop = false;
        this.selectedFiltersArr = [];
        this.filterControlSettingsObj = {};
        this.gettingAdditionalData = false;
        this.additionalDataLoad = null;
        this.cancelUpdateAdditionalData = false;
        this.helper = new StocksHelper();
        this.tabEmit = new EventEmitter<TabSelect>();
    }


    @Input() filterControlSettings: FilterControlSettings[];
    @Input() isAdmin: boolean;
    // @Input() separator: string[];
    @Input() additionalData: AdditionalFilterData[];
    @Input() GUID: string;
    @Input() controller?: string;
    @Input() module: string;
    @Input() componentInfoData?: ComponentInfo;
    @Input() customButtons?: StocksToolbarButtonsSettings[];

    @Output() tabEmit: EventEmitter<TabSelect>;

    // public isInitialized: boolean;
    private locale: string;
    private subscription: ISubscription;
    private subscriptionState: ISubscription;
    private subscriptionScroll: ISubscription;
    private subscriptionSelectedFilter: ISubscription;
    private subscriptionUpdateSelectedFilter: ISubscription;
    private subscriptionFocus: ISubscription;
    private subscriptionHideGrid: ISubscription;
    private subscriptionGetAdditionalData: ISubscription;
    private subscriptionShowFilters: ISubscription;
    private _filter: StocksFilter;
    private filtersState: StocksFiltersState;
    public showAllFilters: boolean;
    public codeNameFilter: FilterControlSettings[];
    public numberFilter: FilterControlSettings[];
    private scrollPosition: number;
    private develop: boolean;
    private _selectedFilters: any;
    public selectedFiltersArr: SelectedFilter[];
    private initScroll: boolean;
    private filterControlSettingsObj: any;
    private gettingAdditionalData: boolean;
    private cancelUpdateAdditionalData: boolean;
    public disableApply: boolean;
    private additionalDataLoad: { param: string, filter: StocksFilter };
    private helper: StocksHelper;
    private removeScrollListener: Function;
    public testHide: boolean;
    public selectTab: TabSelect;

    public get selectTabType(): typeof TabSelect{
        return TabSelect
    }

    @ViewChild('filtersWrapper')
    private filtersWrapper: ElementRef;

    @ViewChild('selectedFiltersWrapper')
    private selectedFiltersWrapper: ElementRef;

    @ViewChild('clearBtn')
    private clearBtn: ElementRef;

    @ViewChild('cancelBtn')
    private cancelBtn: ElementRef;

    @ViewChild('applyBtn')
    private applyBtn: ElementRef;


    // protected initialDataLoader = this.stocksService.GetPermissions;
    //
    // protected onInitialDataLoaded = (data: InitialData, hideLoadingImg: () => void): void =>{
    //     hideLoadingImg();
    //     this.isInitialized = true;
    // };

    ngOnInit(){

        !this.module ? this.module = 'Filter' : null;
        this.controller ? this.filterService.controller = this.controller : null;

        this.selectTab = TabSelect.First;
        this.tabEmit.emit(this.selectTab)

        // if (this.customButtons){
        //     this.selectTab = TabSelect.First;
        // }

        // this.testHide = true;
        // this.helper.wait(() => this.testHide = false, 10000)

        //# update filter if some change happened in filters
        this.subscription = this.filterService.stocksFilterCurrent.subscribe((res: StocksFilterGUID[]) =>{
            this.helper.tryCatch(() =>{

                let found: StocksFilterGUID = this.helper.getGUIDObj(res, this.GUID);
                // console.log(found, 'stocksFilterCurrent')
                if (found)
                    // console.log(found, 'compareSimpleObj')
                    this.filter = found.stocksFilter;
            })

        });
        //# update filtersState if some change happened in filters, show which filter was updated
        this.subscriptionState = this.filterService.stocksFiltersStateCurrent.subscribe((res: StocksFiltersStateGUID[]) =>{
            this.helper.tryCatch(() =>{
                let found: StocksFiltersStateGUID = this.helper.getGUIDObj(res, this.GUID);
                if (found && !this.helper.compareSimpleObj(this.filtersState, found.stocksFiltersState))
                    this.filtersState = found.stocksFiltersState
            })

        });
        //# update scroll position
        this.subscriptionScroll = this.filterService.filtersScrollCurrent.subscribe(res => this.helper.tryCatch(() => this.scrollPosition = res));

        //# update selected filters if we have occur in filters
        this.subscriptionSelectedFilter = this.filterService.selectedFiltersCurrent.subscribe((res: SelectedFilterGUID) =>{
            this.helper.tryCatch(() =>{
                if (res && res.GUID === this.GUID){
                    this.selectedFilters = res.selectedFilters
                }
            })

        });
        //# update selected filters if we have occur in filters
        this.subscriptionUpdateSelectedFilter = this.filterService.updateSelectedFiltersCurrent.subscribe((res: AdditionalFilterDataGUID) =>{
            this.helper.tryCatch(() =>{
                if (res && res.GUID === this.GUID){
                    this.updateSelectedFilters = res.additionalFilterData
                }
            })
        });
        //# change focus, jump from one filter to another
        this.subscriptionFocus = this.filterService.goToNextFilter2Current.subscribe((res: FocusGUID) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.focus = res.focus : null)
        );
        //# change scroll position for selected-filter, if we open or close grid inside selected-filter
        this.subscriptionHideGrid = this.filterService.hideGridSelectedFiltersCurrent.subscribe((res: { GUID: string, show: boolean }) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.showSelectedFilterGrid = res.show : null)
        );
        //# get additional data for else filters filter. If we change some filter restrictions for else filters change, this subscriber updates restriction for all filters  (additional data is display data for selected-filter)
        this.subscriptionGetAdditionalData = this.filterService.getAdditionalDataCurrent.subscribe((res: { GUID: string, param: string, filter: StocksFilter }) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.getAdditionalData = {param: res.param, filter: res.filter} : null)
        );
        //# toggle visibility of main filter component
        this.subscriptionShowFilters = this.filterService.showFiltersCurrent.subscribe((res: { GUID: string, show: boolean }) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.showFilters = res.show : null)
        );

        //# set filters visibility based from settings
        this.filterControlSettings.forEach(item =>{
            if (item.visibility === 0){
                item.show = false;
            } else if (item.visibility === 1 && this.isAdmin){
                item.show = true;
            } else if (item.visibility === 2){
                item.show = true;
            }
        });

        this.filterControlSettings = this.filterControlSettings.filter(item => item.type && item.show);

        //# set position for filters
        this.filterControlSettings.sort(function (a: any, b: any){
            return a.position - b.position;
        });

        //# convert arr to obj
        this.filterControlSettings.forEach(item =>{
            this.filterControlSettingsObj[item.name.toLowerCase()] = item;
        });

        this.addSavedFilter().then();


    }

    public testData = async (): Promise<void> =>{


        let filters = ['Warehouses', 'SKUs', 'Suppliers', 'ExtSuppliers', 'Category', 'Group',
            'Subgroup1', 'Subgroup2', 'Subgroup3', 'Subgroup4', 'Subgroup5', 'State', 'StoreType', 'BufferZones', 'BufferLimits',
            'LimitedByMaxShelfQnt', 'LimitedByMaxPackage', 'LimitedByMaxBuffer', 'ActionMovers', 'SeasonMovers', 'SpeedMovers', 'TopMovers', 'ThrMovers', 'LspeedMovers'
            , 'LtopMovers', 'LthrMovers', 'Fresh', 'New', 'FirstPrice', 'SupplierHoliday', 'BlockedToOrder'];

        filters.forEach(item => item.toLowerCase());

        let filter = new StocksFilter();

        filter.warehouses = ['w1001'];

        ///console.log(filter, 'filter');

        let data = [];



        for (let i = 0; i < filters.length; i++){
            let datas = await this.filterService.GetDataForCodeNameFilter(filters[i], filter).toPromise();
            //console.log(filters[i], 'filters.forEach');
            //console.log(new Date().getTime() - d, 'filters.forEach');

            data.push(datas)
        }


        let v = new Date().getTime();
        //console.log(v - d, 'time');

        //console.log(data, 'data');
    };

    ngOnDestroy(){
        this.subscription.unsubscribe();
        this.subscriptionState.unsubscribe();
        this.subscriptionScroll.unsubscribe();
        this.subscriptionSelectedFilter.unsubscribe();
        this.subscriptionUpdateSelectedFilter.unsubscribe();
        this.subscriptionHideGrid.unsubscribe();
        this.subscriptionGetAdditionalData.unsubscribe();
        this.subscriptionShowFilters.unsubscribe();
        this.removeScrollListener();
    }

    ngAfterViewInit(){
        this.showModal();
        this.removeScrollListener = this.renderer.listen(this.filtersWrapper.nativeElement, 'scroll', () =>{
            this.filterService.setFiltersScroll($(this.filtersWrapper.nativeElement).scrollTop());
        });
        // let res = this.module
        //     ? await this.commonData.saveUserProp.getSlickGridProperties(this.module, this.filterControlSettings.map(f => f.name + 'Filter')).toPromise()
        //     : null
        //
        // if (res && res.success){
        //     let data: SlickGridColumns[] = JSON.parse(res.data);
        //     if (data && data.length){
        //         this.filterControlSettings.forEach(fc =>
        //             data.forEach(d => {
        //                 if (fc.name === d.tableName.substring(0, d.tableName.length - 6)){
        //                     fc.dimensions.width = d.data[0][0].width;
        //                     fc.dimensions.height = d.data[0][1].width;
        //                     console.log(fc.name, fc.dimensions, 'this.dimensions 2')
        //                 }
        //             })
        //         )
        //     }
        // }


        // $(this.filtersWrapper.nativeElement).scroll(() => {
        //     this.filterService.setFiltersScroll($(this.filtersWrapper.nativeElement).scrollTop());
        // });
    }

    ngAfterViewChecked(){
        if (!this.showAllFilters){
            let timeout = setTimeout(() =>{
                clearTimeout(timeout);
                timeout = null;
                this.showAllFilters = true;
            }, 0);
        }
    }

    //# show of hide main filter
    set filter(filter: StocksFilter){
        if (filter !== null){
            this._filter = filter;
            this.disableApply = this.helper.stocksFilterEmpty(filter);
        }
    };

    get filter(): StocksFilter{
        return this._filter;
    };

    //# show of hide main filter
    set showFilters(val: boolean){
        if (val !== null){
            val ? this.showModal() : this.hideModal();
        }
    };

    //# set scroll for selected-filter
    set showSelectedFilterGrid(value: boolean){
        if (this.initScroll){
            setTimeout(() =>{
                let top = $('.selected-filters-cnt .wrp.selected').parent().position().top;
                let scroll = this.selectedFiltersWrapper.nativeElement.scrollTop;
                $(this.selectedFiltersWrapper.nativeElement).animate({scrollTop: top + scroll}, 150);
            }, 5);
        }
        this.initScroll = true;
    };

    //# rule filter focus, set it to some filter
    set focus(focus: Focus){
        if (focus){
            //console.log(this.filterControlSettings);
            let currentPosition: number = null,
                targetPosition: number = null,
                filtered: FilterControlSettings[] = [];
            this.filterControlSettings.forEach(item =>{
                if (focus.param === item.name){
                    //currentPosition = focus.direction === 'next' ? item.position + 1 : item.position - 1;
                    currentPosition = item.position;
                }
            });

            filtered = this.filterControlSettings.filter(item => focus.direction === 'next' ? item.position > currentPosition : item.position < currentPosition);

            if (filtered.length > 0){
                targetPosition = focus.direction === 'next' ? Math.min.apply(null, filtered.map(item => item.position)) : Math.max.apply(null, filtered.map(item => item.position));
            } else{
                targetPosition = focus.direction === 'next' ? Math.min.apply(null, this.filterControlSettings.map(item => item.position)) : Math.max.apply(null, this.filterControlSettings.map(item => item.position));
            }

            this.filterControlSettings.forEach(item =>{
                if (targetPosition === item.position){
                    this.filterService.setGoToNextFilter({GUID: this.GUID, param: item.name});
                }
            })

        }
    }

    //# generate selected filters
    set selectedFilters(value: SelectedFilter[]){
        //console.log(value, 'selectedFilters')
        if (!value) return;

        this._selectedFilters = value;

        value.forEach(item =>{
            if (this.selectedFiltersArr.length > 0){
                let add: boolean = true;
                this.selectedFiltersArr.forEach((inItem, i, arr) =>{
                    if (inItem.name === item.name){
                        add = false;

                        arr[i].data = item.data;
                        arr[i].dataString = item.dataString;
                        arr[i].allItemsQuantity = item.allItemsQuantity;
                        arr[i].selectedQuantity = item.selectedQuantity;
                        if (!item.dataString){
                            arr.splice(i, 1);
                        }
                    }
                });
                if (add && item.dataString){
                    this.selectedFiltersArr.push(item);
                }

            } else{
                if (item.dataString){
                    this.selectedFiltersArr.push(item)
                }
            }
        });


        this.filterService.setUpdateSelectedDataFilters({GUID: this.GUID, selectedFilters:  this.selectedFiltersArr});

    }

    get selectedFilters(): SelectedFilter[]{
        return this._selectedFilters;
    }


    set updateSelectedFilters(data: AdditionalFilterData[]){
        this.updateSelectedFiltersFunc(data).then();
    }

    //# updates data for selected filter
    private updateSelectedFiltersFunc = async (data: AdditionalFilterData[]): Promise<void> =>{
        if (data && data.length > 0){

            let selectedFilters: SelectedFilter[] = [];

            for (let i = 0; i < data.length; i++){
                // await data.forEach(async item => {

                if (this.filterControlSettingsObj[data[i].name.toLowerCase()].translate){
                    data[i].filterData = await this.helper.translateData(data[i].filterData, this.commonData.translateService, 'name', 'name');
                }

                let separator = this.filterControlSettingsObj[data[i].name].separator[0];

                // if (item.filterData.length > 0) {
                let selectedFilter = new SelectedFilter(data[i].name, this.filterControlSettingsObj[data[i].name.toLowerCase()].type, this.filterControlSettingsObj[data[i].name.toLowerCase()].position);
                selectedFilter.allItemsQuantity = data[i].allItemsQuantity;
                selectedFilter.selectedQuantity = data[i].filterData.length;
                selectedFilter.dataString = this.filterControlSettingsObj[data[i].name.toLowerCase()].type !== 1 ? data[i].filterData.map(item => item.name).join(separator) : data[i].filterData.map(item => item.code).join(separator);
                if (data[i].filterData && data[i].filterData.length > 0){
                    selectedFilter.data = data[i].filterData;
                    selectedFilter.data.forEach((item, i) => item.id = i + 1)
                }

                selectedFilters.push(selectedFilter);
                // }
                // });
            }

            this.selectedFilters = selectedFilters;
        }
    };

    /*private translateData = async (data: CodeName[]): Promise<CodeName[]> => {
        if (data && data.length > 0) {
            let names: string[] = data.map(item => item.name);
            let res: any = await this.commonData.translateService.get(names).toPromise();
            for (let i = 0; i < data.length; i++){
                data[i].name = res[data[i].name]
            }
            // data.forEach(item => {
            //     item.name = res[item.name]
            // });
        }
        return data;
    };*/

    //# update additional data if we have some changes in other filters
    private set getAdditionalData(data: { param: string, filter: StocksFilter }){
        if (!data) return;

        if (data.param !== 'cancelUpdate' && !this.filterControlSettings.find(fcs => fcs.name === data.param).innerFiltering) return;

        if (data.param === 'cancelUpdate'){
            this.gettingAdditionalData = false;
            this.additionalDataLoad = null;
            this.cancelUpdateAdditionalData = true;
            return;
        }

        if (this.gettingAdditionalData){
            this.additionalDataLoad = data;
            return;
        }

        this.getAdditionalDataLoad(data);
    }

    //# load additional data
    private getAdditionalDataLoad = (data: { param: string, filter: StocksFilter }): void =>{
        this.gettingAdditionalData = true;
        this.filterService.GetDataAdditionalDataFilter(data.param, data.filter).subscribe((res: AdditionalFilterData[]) =>{
            this.gettingAdditionalData = false;
            // console.log(data, 'getAdditionalDataLoad')
            if (this.cancelUpdateAdditionalData){
                this.cancelUpdateAdditionalData = false;
                return;
            }

            if (this.additionalDataLoad !== null){
                this.getAdditionalDataLoad(this.additionalDataLoad);
                this.additionalDataLoad = null;
            }

            let additionalDataObj = {};
            res.forEach(item => item.filterData.forEach(inItem => {
                inItem.name = inItem.name.trim()
                inItem.code = inItem.code.trim()
            }));
            //console.log(data, 'getAdditionalData load end');
            // console.log(res, 'getAdditional res load end');
            res.forEach(item =>{
                additionalDataObj[item.name] = item;
            });
            this.filterService.setFillFilterAdditionalData({GUID: this.GUID, additionalDataObj: additionalDataObj});
            this.filterService.setUpdateSelectedFilters({GUID: this.GUID, additionalFilterData: res});
        });
    };


    set language(value: string){
        this.locale = value;
        localStorage['UserLocale'] = value;
    }

    get language(): string{
        return this.locale;
    }

    //# show main-filter
    private showModal = (): void =>{
        $('#filter').on('shown.bs.modal',
            e =>{
                $(e.target).off('shown.bs.modal');
            }).on('hidden.bs.modal',
            e =>{
                $(e.target).off('hidden.bs.modal');
            }).modal({backdrop: 'static', keyboard: false});
    };

    //# hide main-filter
    private hideModal = (): void =>{
        $('#filter').modal('hide');
    };

    //# hide with animation (no use now)
    public closeAnimated = (): void =>{
        this.hideModal();
        let wait = setTimeout(() =>{
            clearTimeout(wait);
            wait = null;
            //this.close.emit();
        }, 500);

    };

    // clear data in all filters
    public clearFilters = (): void =>{
        // this.showAllFilters = false;
        this.filterService.setFilter({GUID: this.GUID, stocksFilter: new StocksFilter()});
        this.filterService.setFiltersState({GUID: this.GUID, stocksFiltersState: new StocksFiltersState()});
        this.selectedFiltersArr = [];
        this.filterService.setClearFilter({GUID: this.GUID, command: 'clear'});

        //this.filterService.setSelectedFilters(new SelectedFilter('', null, null));
    };

    //# apply filter and get main-data for stocks
    public applyFilter = (): void =>{

        // this.commonService.sendGA('clicks', 'stclc', 'applyFilter', 20)

        this.hideModal();
        this.filterService.setStocksData({GUID: this.GUID, command: 'get'});
    };

    private objToArr = (data: any): any[] =>{
        let arr: any[] = [];
        for (let prop in data){
            arr.push(data[prop]);
        }
        return arr;
    };

    /*public differenceBetweenArr = (a1: SelectedFilter[], a2: SelectedFilter[]): SelectedFilter[] => {
        let a = [], diff = [];

        for (let i = 0; i < a1.length; i++) {
            a[a1[i].name] = true;
        }

        for (let i = 0; i < a2.length; i++) {
            if (a[a2[i].name]) {
                delete a[a2[i].name];
            } else {
                a[a2[i].name] = true;
            }
        }

        for (let k in a) {
            diff.push(k);
        }
        return diff;
    };*/

    /*public removeItem = (a1: SelectedFilter[], a2: SelectedFilter[]): void => {
        a1.forEach((item, index, object) => {
            a2.forEach(inItem => {
                if (item.name === inItem.name) {
                    object.splice(index, 1);
                }
            })
        })
    };*/

    private objToArrOfObj = (data: any): any[] =>{
        let arr: any[] = [];
        for (let prop in data){
            if (data[prop + 'name']){
                arr.push({data: data[prop], name: prop, dataName: data[prop + 'name']});
            } else{
                arr.push({data: data[prop], name: prop});
            }

        }
        return arr;
    };

    //# set data to filters from previous saved filters
    private addSavedFilter = async (): Promise<void> =>{
        let savedFilters: any[] = this.objToArrOfObj(this.filter);
        savedFilters = savedFilters.filter(item =>{
            if (item && item.data && (item.data.length > 0 || item.data.operation !== 0)){
                return true;
            }
        });
        savedFilters.forEach((item) =>{
            savedFilters.forEach((inItem, i, arr) =>{
                if (item.name + 'name' === inItem.name)
                    arr.splice(i, 1);
            });
        });

        for (let i = 0; i < savedFilters.length; i++ ){
            for (let a = 0; a < this.filterControlSettings.length; a++ ){
                if (savedFilters[i].name.toLowerCase() === this.filterControlSettings[a].name.toLowerCase()){
                    savedFilters[i].position = this.filterControlSettings[a].position;
                    savedFilters[i].type = this.filterControlSettings[a].type;

                    if (this.filterControlSettings[a].type === 5){
                        let type;
                        switch (savedFilters[i].data.operation){
                            case 1:
                                type = '=';
                                break;
                            case 2:
                                type = '≠';
                                break;
                            case 3:
                                type = '<';
                                break;
                            case 4:
                                type = '≤';
                                break;
                            case 5:
                                type = '≥';
                                break;
                            case 6:
                                type = '>';
                                break;
                            case 7:
                                type = await this.translateService.get('Between').toPromise();
                                break;
                        }
                        if (savedFilters[i].data.operation === 7){
                            type += ' ' + savedFilters[i].data.values[0] + ' - ' + savedFilters[i].data.values[1];
                        } else{
                            type += ' ' + savedFilters[i].data.values[0];
                        }
                        savedFilters[i].dataStr = type;
                    }
                }
            }
        }

        /*await savedFilters.forEach(async (item, i, arr) =>{
            this.filterControlSettings.forEach(async inItem =>{
                if (item.name.toLowerCase() === inItem.name.toLowerCase()){
                    arr[i].position = inItem.position;
                    arr[i].type = inItem.type;

                    if (inItem.type === 5){
                        let type;
                        switch (item.data.operation){
                            case 1:
                                type = '=';
                                break;
                            case 2:
                                type = '≠';
                                break;
                            case 3:
                                type = '<';
                                break;
                            case 4:
                                type = '≤';
                                break;
                            case 5:
                                type = '≥';
                                break;
                            case 6:
                                type = '>';
                                break;
                            case 7:
                                type = await this.translateService.get('Between').toPromise();
                                break;
                        }
                        if (item.data.operation === 7){
                            type += ' ' + item.data.values[0] + ' - ' + item.data.values[1];
                        } else{
                            type += ' ' + item.data.values[0];
                        }
                        arr[i].dataStr = type;
                    }
                }
            })
        });*/

        /*await savedFilters.forEach(async (item, i, arr) => {
            await this.additionalData.forEach(async (inItem) => {
                if (item.name.toLowerCase() === inItem.name){

                    if (item.type === 1 || item.type === 2 || item.type === 4) {
                        arr[i].selectedQuantity = inItem.filterData.length;
                        arr[i].allItemsQuantity = inItem.allItemsQuantity;
                        if (this.filterControlSettingsObj[item.name.toLowerCase()].translate) {
                            inItem.filterData = await this.translateData(inItem.filterData);
                            console.log(inItem.filterData, 'savedFilters.forEach');
                        }
                        arr[i].data = inItem.filterData;
                    }

                    if (item.type === 1) {
                        arr[i].dataStr = inItem.filterData.map(item => item.code).join(this.separator);
                    } else if (item.type === 2 || item.type === 4) {

                        arr[i].dataStr = inItem.filterData.map(item => item.name).join(this.separator);
                    } else if (item.type === 3) {
                        arr[i].dataStr = inItem.filterData.length;
                        arr[i].dataStr = arr[i].dataStr + ' ' + inItem.filterData.map(item => item.name).join(this.separator);
                    }

                }
            })
        });*/

        for (let i = 0; i < savedFilters.length; i++){
            for (let a = 0; a < this.additionalData.length; a++){
                if (savedFilters[i].name.toLowerCase() === this.additionalData[a].name){
                    if (savedFilters[i].type === 1 || savedFilters[i].type === 2 || savedFilters[i].type === 4){
                        savedFilters[i].selectedQuantity = this.additionalData[a].filterData.length;
                        savedFilters[i].allItemsQuantity = this.additionalData[a].allItemsQuantity;
                        if (this.filterControlSettingsObj[savedFilters[i].name.toLowerCase()].translate){
                            this.additionalData[a].filterData = await this.helper.translateData(this.additionalData[a].filterData, this.commonData.translateService, 'name', 'name');
                            // console.log(this.additionalData[a].filterData, 'savedFilters.forEach');
                        }
                        savedFilters[i].data = this.additionalData[a].filterData;
                    }

                    let separator = this.filterControlSettingsObj[this.additionalData[a].name].separator[0];

                    if (savedFilters[i].type === 1){
                        savedFilters[i].dataStr = this.additionalData[a].filterData.map(item => item.code).join(separator);
                    } else if (savedFilters[i].type === 2 || savedFilters[i].type === 4){
                        savedFilters[i].dataStr = this.additionalData[a].filterData.map(item => item.name).join(separator);
                    } else if (savedFilters[i].type === 3){
                        savedFilters[i].dataStr = this.additionalData[a].filterData.length;
                        savedFilters[i].dataStr = savedFilters[i].dataStr + ' ' + this.additionalData[a].filterData.map(item => item.name).join(separator);
                    }
                }
            }
        }
        savedFilters.forEach(item =>{
            let selectedFilter: SelectedFilter = new SelectedFilter(item.name, item.type, item.position);
            //selectedFilter.data = selected;
            selectedFilter.dataString = item.dataStr;
            if (item.type === 1 || item.type === 2 || item.type === 4){
                selectedFilter.selectedQuantity = item.selectedQuantity;
                selectedFilter.allItemsQuantity = item.allItemsQuantity;
                if (item.data && item.data.length > 0){
                    selectedFilter.data = item.data;
                    selectedFilter.data.forEach((item, i) => item.id = i + 1)
                }

            }
            this.selectedFiltersArr.push(selectedFilter);
            this.filterService.setSelectedStorageFilters(new SelectedFilterGUID(this.GUID, this.selectedFiltersArr))
            //selectedFilter.allItemsQuantity = this.data.length;
        });


        /*let selectedFilter: SelectedFilter = new SelectedFilter(this.param, this.type, this.position);
        selectedFilter.selectedQuantity = this.getArrFromString(this.inputData).length;
        selectedFilter.dataString = this.inputData;

        this.selectedFilters = selectedFilter;*/
    };

    //# set focus for bottom buttons
    public handleKeys = (e: KeyboardEvent): void =>{
        if (e && e.ctrlKey && !e.repeat){
            if (e.keyCode === 13){
                this.applyBtn.nativeElement.focus();
            } else if (e.keyCode === 8){
                this.clearBtn.nativeElement.focus();
            }
        }
    };

    //# actions form bottom buttons
    public handleButtonKeys = (e: KeyboardEvent, button: string): void =>{
        if (e && e.keyCode === 13){
            switch (button){
                case 'apply':
                    this.applyFilter();
                    break;
                case 'clear':
                    this.clearFilters();
                    break;
                case 'close':
                    this.closeAnimated();
                    break;
            }
        } else if (e && e.keyCode === 37) {
            switch (button){
                case 'apply':
                    this.clearBtn.nativeElement.focus();
                    break;
                case 'clear':
                    this.cancelBtn.nativeElement.focus();
                    break;
                case 'close':
                    break;
            }
        } else if (e && e.keyCode === 39) {
            switch (button){
                case 'close':
                    this.clearBtn.nativeElement.focus();
                    break;
                case 'clear':
                    this.selectedFiltersArr && this.selectedFiltersArr.length
                        ? this.applyBtn.nativeElement.focus()
                        : null;
                    break;
                case 'apply':
                    break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/components/main-filter.component/main-filter.component.ts